<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import { useAnalysisStore } from '@/store/modules/analysis'
import {
  removeAsterisk,
  splitKeywordParts,
  splitBySentence,
  splitSentencesByDivider,
  splitCommaSeparatedWords,
} from '@/composables/splitSentence'
import PersonalPieChart from './PersonalPieChart.vue'
import PersonalityKeyword from './PersonalityKeyword.vue'

const props = defineProps({
  pData: Object,
  userName: String,
  isMobile: Boolean,
})
const store = useAnalysisStore()
// const userName = computed(() => store.userName)
onMounted(() => {
  // pData.value = store.analysisResult;
})

const myEnergy = computed(() => splitBySentence(props.pData.기운방향.기본특성))
const myRhythm = computed(() => splitBySentence(props.pData.기운방향.상세특성))
const strengthItems = computed(() => splitCommaSeparatedWords(props.pData.기운방향.주요강점))
const weaknessItems = computed(() => splitCommaSeparatedWords(props.pData.기운방향.주요약점))
const strengthDetail = computed(() => splitBySentence(props.pData.기운방향.강점설명))
const weaknessDetail = computed(() => splitBySentence(props.pData.기운방향.약점설명))
const strengthAdvice = computed(() => props.pData.기운방향.강점조언)
const weaknessAdvice = computed(() => props.pData.기운방향.약점조언)

const nCodeData = computed(() => props.pData.낭만성향.성향분포.NCODE_RTOS['ei_rto'])
const parsedEI = computed(() => {
  const type = nCodeData.value[0]
  const value = Number(nCodeData.value[1]) || 0
  let e = 0
  let i = 0
  if (type === 'E') {
    e = value
    i = 100 - e
  } else if (type === 'I') {
    i = value
    e = 100 - i
  }
  return { e, i }
})
const eiChartData = computed(() => ({
  'E (외향적 성향)': parsedEI.value.e.toFixed(1),
  'I (내향적 성향)': parsedEI.value.i.toFixed(1),
}))
const eiLabelList = ['E (외향적 성향)', 'I (내향적 성향)']
const eiColorMap = {
  'E (외향적 성향)': '#4EAEEA',
  'I (내향적 성향)': '#FF6867',
}
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="detail-card__top-title personality">
          <span class="detail-tit__num personality">5</span>
          <span class="detail-tit__txt personality">나의 성향이 향하는 방향</span>
        </div>
        <div class="personality-wrapper">
          <div class="person-content-box">
            <div class="personality-chart__wrapper">
              <PersonalPieChart
                :chartData="eiChartData"
                :labelList="eiLabelList"
                :colorMap="eiColorMap"
                centerTitle="기운방향"
                labelDirection="row"
              />
            </div>
          </div>
          <div class="personality-divider" />
          <div class="person-content-box">
            <PersonalityKeyword
              :left-title="['나를 말해주는', '단어들 😊']"
              :keywords="props.pData.기운방향.주요특징"
              :isMobile="isMobile"
            />
          </div>
          <div class="personality-divider" />

          <div class="person-content-box">
            <div class="content__title">⚡️ 사주로 본 나의 핵심 에너지는?</div>
            <div v-for="(sentence, idx) in myEnergy" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
          <div class="personality-divider" />
          <div class="person-content-box">
            <!-- <div class="content__title">

            </div> -->
            <div v-for="(sentence, idx) in myRhythm" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">👍 내가 주변에 주는 긍정적인 영향</div>
            <div class="desc__body blue">
              <div class="top-keyword">
                <div class="top-keyword__box">
                  <div v-for="(item, idx) in strengthItems" :key="idx" class="keyword-item blue">
                    {{ item }}
                  </div>
                </div>
                <div v-for="(str, idx) in strengthDetail" :key="idx" class="top-keyword__desc">
                  {{ str }}
                </div>
              </div>
              <div class="bottom-white-box">
                <div class="white-box__tit">이런 환경에서 나의 장점이 잘 살아나요. 😏</div>
                <div class="white-box__desc">
                  {{ strengthAdvice }}
                </div>
              </div>
            </div>
          </div>
          <div class="person-desc-box">
            <div class="desc__title">💦 내가 어려워 할 수 있는 것들</div>
            <div class="desc__body red">
              <div class="top-keyword">
                <div class="top-keyword__box">
                  <div v-for="(item, idx) in weaknessItems" :key="idx" class="keyword-item red">
                    {{ item }}
                  </div>
                </div>
                <div v-for="(str, idx) in weaknessDetail" :key="idx" class="top-keyword__desc">
                  {{ str }}
                </div>
              </div>
              <div class="bottom-white-box">
                <div class="white-box__tit">나를 위한 작은 연습 😙</div>
                <div class="white-box__desc">
                  {{ weaknessAdvice }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
